import { useEffect, useState } from 'react'
import { supportWidget } from './support-globals'

// Subscribe to the embed.js bootstrap's eligibility state. The script
// publishes its widget global asynchronously after the page bundle
// runs, so we may need to poll briefly until it lands.
export function useSupportChatEligible(): boolean {
  const [active, setActive] = useState(() => supportWidget()?.active ?? false)

  useEffect(() => {
    let unsubscribe: (() => void) | null = null
    let timer: number | null = null

    const attach = (): boolean => {
      const support = supportWidget()
      if (!support) return false
      setActive(support.active)
      unsubscribe = support.subscribe(setActive)
      return true
    }

    if (!attach()) {
      let attempts = 0
      timer = window.setInterval(() => {
        if (attach() || ++attempts > 100) {
          if (timer !== null) {
            window.clearInterval(timer)
            timer = null
          }
        }
      }, 50)
    }

    return () => {
      if (timer !== null) window.clearInterval(timer)
      if (unsubscribe) unsubscribe()
    }
  }, [])

  return active
}
